import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { CustomButton } from '../../../../components';

function CardButtons({ onHandleClick, primaryButton, secondaryButton, eventId }) {
  return (
    <Grid container gap={2}>
      <Grid item xs={5}>
        <CustomButton variant="outlined" onClick={(e) => onHandleClick(e, 'primary', eventId)}>
          {primaryButton}
        </CustomButton>
      </Grid>
      <Grid item xs={5} display="flex" justifyContent="flex-end">
        <CustomButton variant="contained" onClick={(e) => onHandleClick(e, 'secondary', eventId)}>
          {secondaryButton}
        </CustomButton>
      </Grid>
    </Grid>
  );
}

CardButtons.propTypes = {
  eventId: PropTypes.number.isRequired,
  onHandleClick: PropTypes.func.isRequired,
  primaryButton: PropTypes.string.isRequired,
  secondaryButton: PropTypes.string.isRequired,
};

export default CardButtons;
